import {DojoDeshi} from '../DojoDeshi.js';
import {DojoTemplates} from '../DojoTemplates.js';
import {Eventify} from '../Eventify.js';
import signals from '../lib/signals.js';

export class DOMInput {
	constructor(js, model) {
		this.js = js;
		this.model = model;
		this.makeDOM();
		this.model.changed.add(this.modelChanged, this);
		this.value = model.getField(this.js.name);
		this.ignoreSet = true;
	}
	makeDOM() {
		this.el = document.createElement('input');
		this.el.setAttribute('type', this.getType());
		this.copyAttributes(this.el);
		this.setChangeListener(this.el);
	}
	getType() {
		return (undefined==this.js.type) ? 'text' : this.js.type;
	}
	getChangeEvent() {
		return (undefined==this.js.changeEvent) ? "input" : this.js.changeEvent;
	}
	getAttribute(attr, def) {
		if ((undefined==this.js.attributes) ||
			(undefined==this.js.attributes[attr])) {
			return def;
		}
		return this.js.attributes[attr];
	}
	copyAttributes(el) {
		for (let a in this.js.attributes) {
			el.setAttribute(a, this.js.attributes[a]);
		}
	}
	setChangeListener(el) {
		el.addEventListener(this.getChangeEvent(), (evt)=>{
			this.model.setField(this.js.name, this.value, this);
		});
	}
	modelChanged(name, value, model, src) {
		if (src==this) {
			return;
		}
		if ((name==this.js.name) && (value!=this.value)) {
			this.value = value;
		}
	}
	// If the value is undefined, how does this Field type show the data
	undefinedValue() {
		return '';
	}
	set value(v) {
		if (undefined != v) {
			this.el.value = v;
		} else {
			this.el.value = this.undefinedValue();
		}
	}
	get value() {
		return this.el.value;
	}
	get DOM() {
		return this.el;
	}
}

export class DOMInputNumber extends DOMInput {
	get value() {
		return parseInt(this.el.value);
	}
}

export class DOMInputCodeMirror extends DOMInput {
	makeDOM() {
		this.el = document.createElement('div');
		let jsMode = this.getAttribute('mode','json');
		this.codeMirror = CodeMirror(this.el, {
			"mode": {
				"name":"javascript",
				jsMode:true
			}
		});
		this.codeMirror.on('change', (evt)=>{
			this.model.setField(this.js.name,this.value,this);
		});
	}
	get value() {
		let s = this.codeMirror.getValue();
		try {
			let js = JSON.parse(s);
			return js;
		} catch (e) {
			return {};
		}
	}
	set value(v) {
		if (JSON.stringify(v) == JSON.stringify(this.value)) {
			return;
		}
		// We ignore the next call to value, which will be the
		// model changing... hopefully...
		// this.ignoreSet = true;
		// @TODO I'm not too sure about this ignoreSet approach...
		// going to stick with direct comparison for now.
		if (undefined != v) {
			if ('string'==typeof v) {
				this.codeMirror.setValue(v);
				return;
			}
			let js = JSON.stringify(v);
			this.codeMirror.setValue(js);
		} else {
			this.codeMirror.setValue(`{}`);
		}
	}
}

export class DOMInputSelect extends DOMInput {
	makeDOM() {
		this.el = document.createElement('select');
		for (let i in this.js.options) {
			let v = this.js.options[i];
			let o = document.createElement('option');
			o.textContent = v;
			o.setAttribute('value', v);
			this.el.appendChild(o);
		}
		this.copyAttributes(this.el);
		this.el.addEventListener('change', (evt)=>{
			this.model.setField(this.js.name, this.value);		
		});
	}
}

export class DOMInputCheckbox extends DOMInput {
	getChangeEvent() {
		return 'change';
	}
	get value() {
		return this.el.checked;
	}
	set value(v) {
		this.el.checked = (undefined == v) ? false : v;
	}
}

export class FormField {
	constructor(js, model) {
		this.name = js.name;
		this.label = js.label;
		this.placeholder = js.placeholder;
		this.description = js.description;
		this.type = js.type;

		this.el = document.createElement('div');
		let lbl = document.createElement('label');
		let s = document.createElement('span');
		s.textContent = (this.label)?this.label:this.name;
		lbl.appendChild(s);
		let input = {};
		switch (js.type) {
			case 'checkbox':
				input = new DOMInputCheckbox(js,model);
				break;
			case 'codemirror':
				input = new DOMInputCodeMirror(js,model);
				break;
			case 'number':
				input = new DOMInputNumber(js,model);
				break;
			case 'select':
				input = new DOMInputSelect(js,model);
				break;
			default:
				input = new DOMInput(js, model);
				break;
		}
		lbl.appendChild(input.DOM);
		this.el.appendChild(lbl);
	}
	get DOM() {
		return this.el;
	}
}